import React from "react"

import Paragraph from "../../../../../../design-system/paragraph"
import Tooltip from "../../../../../../design-system/tooltip"
import * as styles from "./index.module.scss"

interface Props {
  list: unknown[]
  onClick?: () => void
  children: React.ReactNode
  tooltipContent?: React.ReactNode
}

function ClickableParagraph({
  list,
  onClick,
  children,
  tooltipContent,
}: Props) {
  const hasMultipleItems = list?.length > 1
  if (hasMultipleItems) {
    return (
      <Paragraph
        variant="1"
        onClick={onClick}
        className={styles.clickableParagraph}
      >
        {children}
      </Paragraph>
    )
  }
  if (tooltipContent) {
    return (
      <Tooltip
        className={styles.tooltip}
        contentStyles={{ left: "100%", whiteSpace: "nowrap" }}
        trigger={
          <Paragraph as="span" variant="1">
            {children}
          </Paragraph>
        }
        content={tooltipContent}
      />
    )
  }

  return (
    <Paragraph as="span" variant="1">
      {children}
    </Paragraph>
  )
}

export default ClickableParagraph
